mutation GrantAdminPortalAccess($employeeId: ID, $userId: ID) {
  grantAdminPortalAccess(input: { employeeId: $employeeId, userId: $userId }) {
    userId
    employeeId
  }
}
